import { Box } from '@rbilabs/universal-components';

export const AuthContainer = Box.withConfig({
  justifyContent: 'center',
  position: 'relative',
  borderRadius: 0,
  minHeight: 'full',
  marginX: 'auto',
  paddingX: '$10',

  marginBottom: {
    base: '$4',
    md: 0,
  },

  paddingY: {
    base: '$4',
    md: 0,
  },

  maxWidth: {
    md: '600px',
  },
});
